import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-flights",
    templateUrl: "./flights.component.html",
    styleUrls: ["./flights.component.scss"],
    standalone: false,
})
export class FlightsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
